import { createMemo, createRoot } from "solid-js";

export function latest<T>(signal: () => T): T | undefined {
  return createRoot(() => createMemo(signal))();
}

export function isLoading<T>(signal: () => T) {
  return latest(signal) === undefined;
}
